import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AppComponent } from '../app.component';
import { Batiment } from '../Models/Batiment';
import { cloneDeep, cloneDeepWith } from "lodash";

@Component({
  selector: 'app-modal-recopier',
  templateUrl: './modal-recopier.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-recopier.component.less']
})
export class ModalRecopierComponent implements OnInit {
  globalTxt: any;
  modalsTxt: any;
  arrScaByPicId: any = [];
  arrPieces: any = [];
  modalInfo: any;
  paramPicType: any;
  paramPicId: any;
  fctGetPictoMenu: any;
  batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);

  constructor(
    public app: AppComponent,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.app.dataToolsService.currentModalInfo.subscribe(modalInfo => {
      console.log("modalInfo  => ", modalInfo);
      this.modalInfo = modalInfo;
    });

    this.getInfosInit();
  }

  getInfosInit() {
    // ==> Je recupere quelques params dans l'url
    //const url = window.location.search;
    //const urlParams = new URLSearchParams(url);
    //let paramPicTypeId: any = urlParams.get('PicTypeId');

    // ==> On GET le JSON des Textes globaux
    this.app.dataToolsService.currentGlobalTexts.subscribe(object => {

      // ==> Si l'objet n'est pas encore défini dans les dataTools, alors on appele la fonction dans sharedTools pour remplir l'objet dans les dataTools
      if (!object)
        this.app.sharedToolsService.getGlobalTexts();

      this.globalTxt = object;

      // ==> On CALL les textes des modals
      this.app.sharedToolsService.getJSON('txtModals').subscribe(resp => {
        console.log("resp ==> ", resp);
        this.modalsTxt = cloneDeep(resp.recopierChoix);
        let modalData = JSON.parse(localStorage.getItem('modalOpen')!);

        this.arrScaByPicId = (modalData && modalData.data) ? modalData.data : [];
        this.paramPicType = (modalData && modalData.paramPicType) ? modalData.paramPicType : null;
        this.paramPicId = (modalData && modalData.paramPicId) ? modalData.paramPicId : null;

        this.arrScaByPicId.forEach((sca: any) => {
          sca.arrElementsSelected = [];
          delete sca.avecCablerie;
          delete sca.avecCanalisation;
          delete sca.avecDepose;
          delete sca.cols;
          delete sca.encastre;
          delete sca.hasDetailActive;
          delete sca.optionsCategories;
          //delete sca.isTabActive;

          if (sca.SCA_ID != 1) {
            if (sca.arrCategoriesSelected && sca.arrCategoriesSelected.length > 0) {
              sca.arrCategoriesSelected.forEach((cat: any) => {
                //sca.arrElementsSelected.push(elem);
                if (cat.arrElementsSelected && cat.arrElementsSelected.length > 0) {
                  cat.arrElementsSelected.forEach((elem: any) => {
                    delete elem.arrSousCat;
                    delete elem.hasDetail;
                    delete elem.isDefinitelyAdded;
                    delete elem.isDetail;
                    delete elem.synthese;

                    elem.selectedToCopy = (sca.isTabActive) ? true : false;

                    sca.arrElementsSelected.push(elem);
                  })
                }
              })
            }
          }
          else {
            this.app.apiToolsService.getSrfRfsDmgGet(this.paramPicId).subscribe(resp => {
              console.log("resp getSrfRfsDmgGet ==> ", resp);

              sca.arrElementsSelected = cloneDeep(resp);

              sca.arrElementsSelected.forEach((elem: any) => {
                elem.selectedToCopy = (sca.isTabActive) ? true : false;
              });
            })
          }

        })

        console.log("this.arrScaByPicId ==> ", this.arrScaByPicId);

        // ==> On récupère les pièces
        this.getPieces(parseInt(this.batiment.simulationId!));
      });
    });
  }

  getPieces(simId: any) {
    this.app.apiToolsService.getSinistreByID(simId, true).subscribe(res => {
      console.log("res getSinistreByID ==> ", res);


      this.app.sharedToolsService.getJSON("forFunctions").subscribe(data => {
        this.fctGetPictoMenu = cloneDeep(data.fctGetPictoMenu);
        //console.log("this.fctGetPictoMenu", this.fctGetPictoMenu);

        this.arrPieces = cloneDeep(res);

        this.arrPieces.forEach((pic: any) => {

          let piece: any = this.fctGetPictoMenu.filter((obj: any) => {return obj.picId == pic.type;})[0];

          //let count:any = (pic.count) ? ' ' + pic.count : '';
          //if (piece) pic.label = piece.label + count;

          pic.isActive = (pic.id == +this.paramPicId) ? true : false;
          pic.selectedToCopy = (pic.isActive) ? true : false;
        })
      })
    });
  }

  onChangeTab(_arrPresta: any, _presta: any) {
    // ==> Pour toutes les prestations, on met le KEY isTabActive à false
    _arrPresta.forEach((prest: any) => {
      prest.isTabActive = false;
    })

    // ==> On met le KEY isTabActive à true pour celle où on a cliqué
    _presta.isTabActive = true;
    console.log("onValidateRecopy this.arrScaByPicId => ", this.arrScaByPicId);
  }

  onValidateRecopy() {
    console.log("onValidateRecopy this.arrScaByPicId => ", this.arrScaByPicId);
    console.log("onValidateRecopy this.arrPieces => ", this.arrPieces);

    let copyToPics: any = [];

    this.arrPieces.forEach((pic: any) => {
      if (!pic.isActive && pic.selectedToCopy) {
        console.log("onValidateRecopy pic => ", pic);

        let objToPushInCopyToPics: any = {
          PIC_ID: pic.id,
          arrPrestations: []
        }

        this.arrScaByPicId.forEach((sca: any) => {
          let objPrestaToPush: any = {};
          let arrElementsSelected: any = [];

          objPrestaToPush = cloneDeep(sca);

          if (objPrestaToPush.arrCategoriesSelected) delete objPrestaToPush.arrCategoriesSelected;
          ///delete objPrestaToPush.PRIX_TOTAL;

          if (objPrestaToPush.arrElementsSelected && objPrestaToPush.arrElementsSelected.length > 0) {

            objPrestaToPush.arrElementsSelected.forEach((el: any) => { if (el.selectedToCopy) arrElementsSelected.push(el); });

            if (arrElementsSelected.length > 0) {
              arrElementsSelected.forEach((el: any) => {
                delete el.MOB_ID;
                delete el.selectedToCopy;
                delete el.CMO_ID_ROOT;
                delete el.CMO_LIBELLE;
                delete el.CMO_LIBELLE_ROOT;
                delete el.CMO_REF;
                delete el.CMO_REF_ROOT;
                delete el.MOB_DESCRIPTION;
                delete el.MOB_PRIX;
                delete el.MOB_PRIX_TOTAL;
                delete el.MOB_PRIX_UNIT_HT1;
                delete el.MOB_PRIX_UNIT_HT2;
                delete el.MOB_PRIX_UNIT_HT3;
              });

              objPrestaToPush.arrElementsSelected = cloneDeep(arrElementsSelected);
              objToPushInCopyToPics.arrPrestations.push(objPrestaToPush);
            }
          }
        })

        copyToPics.push(objToPushInCopyToPics);

        console.log("copyToPics ==> ", copyToPics);

        this.app.apiToolsService.dmgModernisationDupli(copyToPics).subscribe(resp => {
          console.log("resp dmgModernisationDupli ==> ", resp);
          this.modalInfo.noFn();
        })
      }
    });

  }

}
